import * as constants from "./../constants";

export interface FilterDrilldownAction {
  type: constants.FILTER_DRILLDOWN;
  newFilterPanelDetailSection: string;
  newFields: string[];
}

export interface FilterDrillUpAction {
  type: constants.FILTER_DRILLUP;
}

export interface FiltersCollapsedAction {
  type: constants.FILTERS_COLLAPSED | constants.FILTERS_EXPANDED;
}

export interface DataLoadedAction {
  type: constants.DATA_LOADED | constants.DATA_REQUESTED;
}

export interface RequestInProgressAction {
  type: constants.REQUEST_IN_PROGRESS;
}

export function filterDrilldown(
  newFilterPanelDetailSection: string,
  newFields?: string[],
): FilterDrilldownAction {
  return {
    type: constants.FILTER_DRILLDOWN,
    newFilterPanelDetailSection,
    newFields: newFields ? newFields : [],
  };
}

export function filterDrillUp(): FilterDrillUpAction {
  return {
    type: constants.FILTER_DRILLUP,
  };
}

export function filtersCollapsed(collapsed: boolean): FiltersCollapsedAction {
  if (collapsed)
    return {
      type: constants.FILTERS_COLLAPSED,
    };
  else
    return {
      type: constants.FILTERS_EXPANDED,
    };
}

export function dataLoaded(): DataLoadedAction {
  return {
    type: constants.DATA_LOADED,
  };
}

export function dataRequested(): DataLoadedAction {
  return {
    type: constants.DATA_REQUESTED,
  };
}
